import { createStore } from 'vuex'
import gameloop        from './modules/gameloop'

export default createStore
({modules: 
  { gameloop }
})